import { UniqueIdentifier } from '@dnd-kit/core'
import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'

import {
  KanbanCardComponentExtraProps,
  KanbanCardComponentType,
  KanbanItemRequiredFields
} from './types'

interface SortableItemProps<T extends KanbanItemRequiredFields & KanbanCardComponentExtraProps> {
  id: UniqueIdentifier
  card: KanbanCardComponentType<T>
}

const SortableItem = <T extends KanbanItemRequiredFields & KanbanCardComponentExtraProps>({
  card: Card,
  ...props
}: SortableItemProps<T>) => {
  const { attributes, listeners, setNodeRef, transform, transition } = useSortable({
    id: props.id
  })

  return (
    <div
      ref={setNodeRef}
      style={{ transform: CSS.Transform.toString(transform), transition }}
      {...attributes}
      {...listeners}
    >
      <Card {...(props as T)} />
    </div>
  )
}

export default SortableItem
